// extracted by mini-css-extract-plugin
module.exports = {"root":"BasicLayout-module--root--2S1LZ","container":"BasicLayout-module--container--1GlI8","containerBasic":"BasicLayout-module--containerBasic--1jrrl"};